/**
 * A non-specific HttpClient error, check `status` property for details
 */
export class HttpClientError extends Error {
  public readonly status: number;

  public constructor(message: string, status: number) {
    super(message);

    this.status = status;
  }
}

/** Error on fetch, except when signal is aborted */
export class NetworkError extends Error {}

/** Error when signal is aborted */
export class AbortSignalError extends Error {}

/** 500ish Server Error response */
export class ServerError extends HttpClientError {}

/** 404 Not Found */
export class NotFoundError extends HttpClientError {
  public constructor(message: string) {
    super(message, 404);
  }
}

/** 400 Bad Request */
export class BadRequestError extends HttpClientError {
  public constructor(message: string) {
    super(message, 400);
  }
}

/** 412 Precondition Failed */
export class PreconditionFailedError extends HttpClientError {
  public constructor(message: string) {
    super(message, 412);
  }
}
